import {AuthenticationErrorResponse, RemoteRequester} from "@eryxcoop/appyx-comm";
import DownloadedFileResponse from "./DownloadedFileResponse";
import BrowserFileDownload from "./BrowserFileDownload";

export default class SaporeRemoteRequester extends RemoteRequester {
    call ({ endpoint, data = undefined, retries = 1 }) {
        return super.call({ endpoint, data }).then((response) => {
            return this._responseOrRetryingAfterRefreshingToken(response, retries,
                () => this.call({ endpoint, data, retries: retries - 1 }));
        });
    }

    download ({ endpoint, data, retries = 1 }) {
        return this._downloadOnce(endpoint, data).then((response) => {
            return this._responseOrRetryingAfterRefreshingToken(response, retries,
                () => this.download({ endpoint, data, retries: retries - 1 }));
        });
    }

    async _downloadOnce(endpoint, data) {
        const httpResponse = await fetch(this._urlFor(endpoint, data), this._buildRequest(endpoint, data));
        if (!httpResponse.ok) {
            return this._buildResponse(await httpResponse.json(), endpoint);
        }
        const download = new BrowserFileDownload(await httpResponse.blob(), httpResponse.headers.get('Content-Disposition'));
        download.save();
        return new DownloadedFileResponse({object: {file_name: download.fileName()}, errors: []});
    }

    _urlFor(endpoint, data) {
        return `${this._baseUrl}/${endpoint.url()}?${this._dataToQueryString(data)}`;
    }

    _responseOrRetryingAfterRefreshingToken(response, retries, retry) {
        if (response instanceof AuthenticationErrorResponse) {
            if (retries > 0) {
                return this._refreshUserTokenAndRetry(retry, response);
            } else {
                this._authorizationManager.session().logOut();
            }
        }
        return response;
    }

    _refreshUserTokenAndRetry (retry, authenticationErrorResponse) {
        return this._authorizationManager.session().refreshUserToken()
            .then(retry)
            .catch(() => {
                this._authorizationManager.session().logOut();
                return authenticationErrorResponse;
            });
    }

    _dataToQueryString(data) {
        let keyValuePairs = [];
        for (let i = 0; i < Object.keys(data).length; i += 1) {
            let key = Object.keys(data)[i];
            let value = Object.values(data)[i];
            if (value) {
                let encoded_value;
                if (typeof value === "object" && value.constructor === Object) {
                    encoded_value = JSON.stringify(value)
                } else {
                    encoded_value = encodeURIComponent(value)
                }
                keyValuePairs.push(`${encodeURIComponent(key)}=${encoded_value}`);
            }
        }
        return keyValuePairs.join('&');
    }

    async callUrlWithFormDataWithFiles(method, formData, headers, endpointUrl) {
        // FIXME: this should be replaced with a proper use of ERYXCOM package when it handles multiple file
        return await fetch(this._baseUrl + endpointUrl, {
            method: method,
            body: formData,
            headers: headers,
            credentials: 'include',
        });

    }
}

